import React from 'react';
import './features.css';
import { Feature } from '../../comp';

const featuresData = [
    {
      title: 'Localização',
      text: 'África, Mozambique.'
    },
    {
      title: 'Telefone',
      text: '+258 85 011 0300'
    },
    {
      title: 'Email',
      text: 'apoio@inovatis.co.mz'
    },
   

   
];
const Features = () => {
  return (
    <div className='gpt3__features section_padding' id='features'>
      <div className='gpt3__features-heading'>
        <h1 className='gradient__text'>
         INOVATIS MZ LTD
        </h1>
        <p className='paragraph'>Impulsionando o desenvolvimento</p>
      </div>

      <div className='gpt3__features-container'>
        {featuresData.map((item,index)=>(
          <Feature
            title={item.title} 
            text = {item.text}
            key={item.title+item.text}
          />
        ))}
      </div>
    </div>
  )
}

export default Features
